module.exports = __webpack_public_path__ + "img/image-project-detail.c4748588.jpg";